module.exports = __webpack_public_path__ + "img/375.0cb59d0b.jpg";